export const serviceLocationTypes = {
  ONLINE: 'online',
  BUSINESS_LOCATION: 'business',
  CUSTOMER_LOCATION: 'customer',
  OHTER_LOCATION: 'custom'
};

export default serviceLocationTypes;
